import { render, staticRenderFns } from "./gc-form-header-toolbar.vue?vue&type=template&id=51b59dea"
import script from "./gc-form-header-toolbar.vue?vue&type=script&lang=js"
export * from "./gc-form-header-toolbar.vue?vue&type=script&lang=js"
import style0 from "./gc-form-header-toolbar.vue?vue&type=style&index=0&id=51b59dea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports